export default __webpack_public_path__ + "static/banner-mobile-220ed8f067daefc76727ac1dcb053a0c.svg";